import Vue from 'vue';
import Nl2br from 'vue-nl2br';

Vue.component('nl2br', Nl2br);



// WEBPACK FOOTER //
// ./src/plugins/nl2br/index.js